// Reusable 4x6 warehouse license-plate label (SKU + LPN barcodes); mapped customer identity.
// Generated by scripts/wms/generate.ts for PHP-409. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomLicensePlateLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  warehouseIdentity: yup.string().nullable().optional(),
  warehouseAddress: yup.string().nullable().optional(),
  sku: yup.string().nullable().optional(),
  skuBarcode: yup.string().nullable().optional(),
  itemDescription: yup.string().nullable().optional(),
  quantity: yup.string().nullable().optional(),
  uom: yup.string().nullable().optional(),
  warehouseLocation: yup.string().nullable().optional(),
  lotCode: yup.string().nullable().optional(),
  expiryDate: yup.string().nullable().optional(),
  purchaseOrder: yup.string().nullable().optional(),
  receivingTicket: yup.string().nullable().optional(),
  receiptDate: yup.string().nullable().optional(),
  licensePlateNumber: yup.string().nullable().optional(),
  licensePlateBarcode: yup.string().nullable().optional(),
})

export type BiomLicensePlateLabelFileData = yup.InferType<
  typeof biomLicensePlateLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomLicensePlateLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomLicensePlateLabelFileMappings: RequiredFileData = {
  customerDisplayName: '3c50dfcf-aad0-4ba3-9097-5db01fccecdb',
  warehouseIdentity: '4af029ac-49f3-48fd-818f-421c4e740824',
  warehouseAddress: '463224d9-35a5-438c-98f1-7091af2665b5',
  sku: 'ad22a34a-03b4-40d8-98b3-6c427eb8a0f5',
  skuBarcode: 'c5900a85-57c3-4cea-a4e3-e2dff07df4e7',
  itemDescription: 'eb18c60a-6dcb-4c36-8987-b79c83ee4d17',
  quantity: 'c7abb5cc-aec2-43c1-ab5b-1f6f7551c908',
  uom: 'b7434e30-d9a6-4fb8-a96c-dbe8739387f8',
  warehouseLocation: '62ff8352-bf78-4ca1-b4c8-2720adb888fa',
  lotCode: 'de36bf35-53a6-4444-a88e-957b7b39cf9a',
  expiryDate: '24c70a71-a8fd-4553-9b1f-7395e597bd99',
  purchaseOrder: '5d608116-19a5-449a-9bf1-df090579c510',
  receivingTicket: '22fe645c-a853-41c4-a17b-ac6f7d2417a4',
  receiptDate: 'a90125c5-b5c6-4623-bdba-8f821cf86011',
  licensePlateNumber: '6da1d84e-7453-43d2-9124-cd58722035e4',
  licensePlateBarcode: '2db82007-72e0-4587-994c-5603fcf095d1',
}
